export function cn(...inputs) {
  const classes = []
  inputs.forEach(input => {
    if (input) {
      if (typeof input === 'string' || typeof input === 'number') {
        classes.push(input)
      } else if (Array.isArray(input)) {
        const inner = cn(...input)
        if (inner) classes.push(inner)
      } else if (typeof input === 'object') {
        Object.keys(input).forEach(key => {
          if (input[key]) classes.push(key)
        })
      }
    }
  })
  return classes.join(' ')
}

export default cn
